// extracted by mini-css-extract-plugin
export default {"link":"aeyn4z","clickable":"qQrFOK","svgRoot":"VDJedC","nonScalingStroke":"l4CAhn"};